import { Link, useLocation } from "react-router";

import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks/useCheckFeatureFlag";
import { Tab, Tabs, TabsList } from "@/shared/foundation/primitives";

import styles from "./DeviceTabs.module.css";
import { useActiveDeviceTab, DeviceTab } from "./useActiveDeviceTabFromUrl";

interface DeviceTabsProps {
  deviceId: string;
}

export function DeviceTabs(_props: DeviceTabsProps) {
  // Derived from the URL each tab's <Link> navigates to, so there is no local
  // tab state that could drift from the address bar.
  const activeTab = useActiveDeviceTab();
  const location = useLocation();
  // Show the Sessions tab only when `release-sessions` is on.
  // The same flag gates the /devices/:deviceId/sessions route in DevicesRoutes.tsx, so
  // hiding the tab here keeps the strip aligned with reachable routes.
  const sessionsTabEnabled = useCheckFeatureFlag("release-sessions");
  // Same flag gates the /devices/:deviceId/metrics route in DevicesRoutes.tsx.
  const metricsTabEnabled = useCheckFeatureFlag("release-metrics");

  const tabs = [
    { tab: DeviceTab.Sessions, label: "Sessions", shown: sessionsTabEnabled },
    { tab: DeviceTab.Datasets, label: "Datasets" },
    { tab: DeviceTab.Files, label: "Files" },
    { tab: DeviceTab.Metrics, label: "Metrics", shown: metricsTabEnabled },
    { tab: DeviceTab.Details, label: "Details" },
    { tab: DeviceTab.Tokens, label: "Tokens" },
  ];

  return (
    <Tabs className={styles.tabs} value={activeTab}>
      <TabsList aria-label="Device">
        {tabs
          .filter(({ shown }) => shown !== false)
          .map(({ tab, label }) => (
            <Tab
              key={tab}
              value={tab}
              nativeButton={false}
              render={
                <Link to={{ pathname: tab, search: location.search }} replace />
              }
            >
              {label}
            </Tab>
          ))}
      </TabsList>
    </Tabs>
  );
}
